var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Typography from '@mui/material/Typography';
import { Prism } from 'react-syntax-highlighter';
import { materialOceanic } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Tip from './GithubQuote/Tip';
import Important from './GithubQuote/Important';
import Style from './index.scss';
import classNames from 'classnames';
import Link from '@mui/material/Link/Link';
var SyntaxHighlighter = Prism;
export default (function (_a) {
    var disallowedElements = _a.disallowedElements, unwrapDisallowed = _a.unwrapDisallowed, children = _a.children;
    return (_jsx(Markdown, { disallowedElements: disallowedElements, unwrapDisallowed: unwrapDisallowed, remarkPlugins: [remarkGfm], components: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            code: function (_a) {
                var node = _a.node, inline = _a.inline, className = _a.className, children = _a.children, props = __rest(_a, ["node", "inline", "className", "children"]);
                var match = /language-(\w+)/.exec(className || '');
                return !inline && match ? (_jsx(SyntaxHighlighter, __assign({ style: materialOceanic, PreTag: "div", language: match[1] }, props, { children: String(children).replace(/\n$/, '') }))) : (_jsx("code", __assign({ className: classNames(className, Style.code) }, props, { children: children })));
            },
            a: function (_a) {
                var children = _a.children, href = _a.href;
                // console.log(children)
                if (children
                    && typeof children === 'object'
                    && 'type' in children
                    && 'props' in children) {
                    var props = children.props, childrenType = children.type;
                    var _b = props, alt = _b.alt, src = _b.src;
                    // && 'alt' in children['props']
                    // && children['props']['alt'] === 'video'
                    // const src = children['props']['src'];
                    if (alt === 'video') {
                        return _jsx("video", { muted: true, autoPlay: true, poster: src, controls: true, loop: true, className: Style.video, children: _jsx("source", { src: href }) });
                    }
                    if (childrenType === 'img' && alt === 'video') {
                        return _jsx("video", { muted: true, autoPlay: true, poster: src, controls: true, loop: true, className: Style.video, children: _jsx("source", { src: href }) });
                    }
                }
                // if (children && typeof children === 'object' && 'type' in children && children['type'] === 'img' && children['props']['alt'] === 'video') {
                //     const src = children['props']['src'];
                //     return <video muted autoPlay poster={src} controls loop className={Style.video}>
                //         <source src={href}></source>
                //     </video>;
                // }
                return _jsx(Link, { href: href, children: children });
                // return <a href={href}>{children}</a>
            },
            img: function (_a) {
                var node = _a.node, children = _a.children, props = __rest(_a, ["node", "children"]);
                // console.log(node, props);
                return _jsx("img", __assign({}, props, { className: Style.img, style: { maxWidth: '100%', height: 'auto' } }));
            },
            h1: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h1", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            h2: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h2", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            h3: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h3", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            h4: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            h5: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h5", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            h6: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "h6", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: children });
            },
            p: function (_a) {
                var children = _a.children;
                return _jsx(Typography, { variant: "body1", gutterBottom: true, children: children });
            },
            blockquote: function (_a) {
                var children = _a.children;
                // console.log(children)
                // console.log(typeof children);
                // console.log(children);
                if (children && typeof children === 'object') {
                    console.log(children);
                    var childArray = children;
                    if (childArray && childArray.length == 3 && childArray[0] === '\n' && childArray[2] === '\n') {
                        var props = childArray[1].props;
                        if (props && props.children && props.children.length >= 1) {
                            var _b = props.children, firstChild = _b[0], leftChildren = _b.slice(1);
                            console.log(firstChild);
                            var regex = /\[!(\w+)\]\n(.*?)$/;
                            var matches = firstChild.match(regex);
                            if (matches) {
                                var type = matches[1]; // "NOTE"
                                var noteContent = matches[2]; // "Some Note Content Goes Here\nWith multiple lines"
                                console.log(type, noteContent);
                                switch (type.toLowerCase()) {
                                    case "tip":
                                        return _jsxs(Tip, { children: [noteContent, leftChildren] });
                                    case "important":
                                        return _jsxs(Important, { children: [noteContent, leftChildren] });
                                    default:
                                        break;
                                }
                                // return <Tip>{noteContent}{leftChildren}</Tip>;
                            }
                        }
                    }
                }
                // if(children
                //     && typeof children === 'object'
                //     && 'type' in children
                //     && 'props' in children) {
                //     const {props, type: childrenType} = children;
                //     const {alt, src} = props as {alt: string, src: string};
                // }
                return _jsx("blockquote", { children: children });
            }
        }, children: String(children) }));
});
